import { useState, useEffect } from "react";

export default function MarketingDataCycleSimulator() {
  let initialProfileData = {
    name: "Alex Smith",
    email: "alex@example.com",
    username: "alexsmith",
    city: "New York",
    state: "NY",
    lastActive: "2026-04-01T12:34:56Z",
    lastPageVisited: "/physics101",
    trialStartDate: "2026-03-6T09:00:00Z",
    trialEndDate: "2026-04-06T09:00:00Z",
  };

  let dataCycleSteps = [
    {
      name: "Collection",
      notes:
        "Data is collected from various sources such as website interactions, mobile app usage, email engagement, and more.",
    },
    {
      name: "Transformation",
      notes:
        "Data is transformed into a consistent format, stitched together to form a unified profile.",
    },
    {
      name: "Segmentation",
      notes:
        "Data is grouped into segments based on shared characteristics or behaviors.",
    },
    {
      name: "Activation",
      notes: "Targeted actions are taken to engage with each segment.",
    },
    {
      name: "Measurement",
      notes:
        "Campaign reports flow back into the system to update profiles and re-evaluate segments, completing the cycle.",
    },
  ];

  const [profileData, setProfileData] = useState(initialProfileData);
  //   const [dataCycleSteps, setDataCycleSteps] = useState(initialDataCycleSteps);
  const [currentStep, setCurrentStep] = useState(null);

  useEffect(() => {
    console.log("change", currentStep);
  }, [currentStep]);

  const handleReset = () => {
    setProfileData(initialProfileData);
    setCurrentStep(null);
  };

  const updateProfileData = (key, value, steps) => {
    if (steps && steps.length > 0) {
      steps.forEach((step, index) => {
        if (index === 0) {
          setCurrentStep(step);
        }
        setTimeout(() => setCurrentStep(step), index * 3000);
      });
      setTimeout(() => setCurrentStep(0), steps.length * 3000);
    }
    // setCurrentStep(step);
    // if (step === 1) {
    //   setTimeout(() => {
    //     setCurrentStep(step + 1);
    //     setTimeout(() => setCurrentStep(0), 2000);
    //   }, 2000);
    // }
    // setDataCycleSteps((pre) => {
    //   const updatedSteps = [...pre];
    //   updatedSteps[step - 1] = {
    //     ...updatedSteps[step - 1],
    //     status: 1,
    //   };
    //   return updatedSteps;
    // });

    // if (step === 1) {
    //   setTimeout(
    //     () =>
    //       setDataCycleSteps((pre) => {
    //         const updatedSteps = [...pre];
    //         updatedSteps[step] = {
    //           ...updatedSteps[step],
    //           status: 1,
    //         };
    //         return updatedSteps;
    //       }),
    //     2000,
    //   );
    // }
    //pre-Functional Update guarantees you are working with the absolute latest data
    //console.log("Updating profile data: ", key, value);

    if (key === "emailClickedFromPhone") {
      let key2 = "mobileDeviceId";
      let value2 = "123333";
      setProfileData((pre) => ({
        ...pre,
        [key]: value,
        [key2]: value2,
      }));
    } else {
      setProfileData((pre) => ({
        ...pre,
        [key]: value,
      }));
    }
  };

  return (
    <>
      <p className="max-w-2xl text-sm text-slate-500 italic mb-6">
        Click the buttons to simulate events and time passing, and watch the
        profile update in real time as it moves through the marketing data
        cycle.
        <br />
        <br />
        Scenario: An online learning platform user completes Physics 101 two
        days before their trial expires. This triggers a trial-conversion email.
        When the user clicks the email, the profile updates again and the cycle
        continues.
        <br />
        <br />
        Note: In a real system, these steps would be triggered automatically by
        backend events and automated processes. The buttons are for
        demonstration only.
      </p>
      <div className="flex flex-wrap-reverse">
        <div className="basis-full md:flex-1 bg-slate-200 flex flex-col items-center p-8 text-center">
          <h3 className="mt-4 mb-4 ">Real-time Profile Data</h3>
          <div className="mt-4 text-4xl animate-pulse">👤</div>
          <div className="mt-4 text-sm text-slate-700 text-left w-full">
            {/*--forEach() returns undefined */}
            {Object.entries(profileData).map(([key, value]) => (
              <p
                className="animate-in fade-in slide-in-from-bottom-4 duration-2000"
                key={key}
              >
                <span className="font-medium">{key}:</span> {value}
              </p>
            ))}
          </div>
        </div>
        <div className="basis-full md:flex-1 bg-blue-200 flex flex-col items-center  p-8">
          <h3 className="mt-4 mb-4">Data Cycle</h3>
          <ul className="mt-4 mb-2 text-sm text-slate-700 text-left w-full">
            {dataCycleSteps.map((step, index) => {
              return (
                <li
                  className="mb-5 flex justify-items-start gap-2 font-medium text-lg"
                  key={index}
                >
                  <div
                    className={`flex items-center justify-center w-10 h-10 rounded-full border-2 border-slate-400 animate-in fade-in duration-2000
                ${currentStep === index + 1 ? "bg-green-400 border-green-400 text-white" : ""}`}
                  >
                    {index + 1}
                  </div>
                  <div className="flex-1">
                    <h4 className="mt-0 mb-1">{step.name}</h4>
                    <p className="text-sm text-slate-500 font-normal animate-in fade-in duration-2000 slide-in-from-bottom-2">
                      {step.notes}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="basis-full md:flex-1 bg-red-300 flex flex-col items-center p-9 text-center">
          <h3 className="mt-4 mb-4 ">
            Events{" "}
            <span className="cursor-pointer" onClick={handleReset}>
              🔄
            </span>
          </h3>
          <div className="mt-4 mb-2 text-sm text-slate-700 text-left w-full">
            {/*}
          <button
            className="bg-indigo-500 hover:bg-indigo-400 text-sm text-white font-bold rounded px-4 py-2 mb-4 cursor-pointer"
            onClick={() =>
              updateProfileData("emailClickedFromPhone", "Weekly Promo", [1, 2])
            }
          >
            Simulate New Event - click on email from phone 📱
          </button>
*/}
            <button
              className="bg-teal-500 hover:bg-teal-400 text-sm text-white font-bold rounded px-4 py-2 cursor-pointer w-full"
              onClick={() =>
                updateProfileData("courseCompleted", "Physics 101", [1])
              }
            >
              Simulate New Event - Alex completes Physics 101 course 🥳
            </button>
            <div className="mt-2 mb-2 text-center">⬇️</div>
            <button
              className="bg-slate-500 hover:bg-slate-400 text-sm text-white font-bold rounded px-4 py-2 cursor-pointer w-full"
              onClick={() =>
                updateProfileData(
                  "[calculated] daysUntilExpiration",
                  "2",
                  [2, 3],
                )
              }
            >
              Simulate time passage - now it's 2 days before trial expiration ⏳
            </button>
            <div className="mt-2 mb-2 text-center">⬇️</div>
            <button
              className="bg-slate-500 hover:bg-slate-400 text-sm text-white font-bold rounded px-4 py-2 w-full"
              onClick={() =>
                updateProfileData(
                  "emailSent",
                  "Trial conversion email sent",
                  [4],
                )
              }
            >
              Email Sent to urge Alex to convert (Triggered by time passage
              event &amp; user segmentation)
            </button>
            <div className="mt-2 mb-2 text-center">⬇️</div>
            <button
              className="bg-teal-500 hover:bg-teal-400 text-sm text-white font-bold rounded px-4 py-2 w-full"
              onClick={() =>
                updateProfileData(
                  "emailClicked",
                  "Conversion CTA clicked",
                  [5, 1],
                )
              }
            >
              Alex clicks on the email CTA. Email engagement data updates the
              profile, and the cycle restarts with new insights. 🔁
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
